import { useMemo } from 'react';
import { HierarchyControlItem, RenderInputValue } from '../HierarchyControl.types';

export function useInputValue<T>(value: T | T[], items: HierarchyControlItem<T>[], render?: RenderInputValue<T>) {
  const inputValue = useMemo(() => {
    if (render) {
      return render(value);
    }
    if (Array.isArray(value)) {
      if (value.length === 1) {
        const item = items.find(e => e.id === value[0]);
        return item?.name || '';
      }
      return `${value.length} of ${items.length}`;
    }
    const item = items.find(e => e.id === value);
    return item?.name || '';
  }, [value, items, render]);

  return inputValue;
}